/**
 * @module Constants/collectors
 * @desc All collectors constant variables
 */

import { createReduxConstant } from "src/helpers";

const prefix = createReduxConstant("COLLECTORS");

/**
 * @module COLLECTORS
 * @desc set list of collector documents
 */
export const SET_COLLECTOR_DOCUMENTS = prefix("SET_COLLECTOR_DOCUMENTS");

/**
 * @module COLLECTORS
 * @desc set loading
 */
export const SET_LOADING = prefix("SET_LOADING");

/**
 * @module COLLECTORS
 * @desc set ts numbers with dedicated version list
 */
export const SET_DATAVERSIONS_LIST = prefix("SET_DATAVERSIONS_LIST");

/**
 * @module COLLECTORS
 * @desc set selected ts number
 */
export const SET_SELECTED_GROUP = prefix("SET_SELECTED_GROUP");

/**
 * @module COLLECTORS
 * @desc set selected ts number
 */
export const SET_SELECTED_DATA_TYPE = prefix("SET_SELECTED_DATA_TYPE");

/**
 * @module COLLECTORS
 * @desc set selected version
 */
export const SET_SELECTED_VERSION = prefix("SET_SELECTED_VERSION");

/**
 * @module COLLECTORS
 * @desc set version list
 */
export const SET_VERSION_LIST = prefix("SET_VERSION_LIST");

/**
 * @module COLLECTORS
 * @desc set data version modal open state
 */
export const SET_DATAVERSION_MODAL_OPEN = prefix("SET_DATAVERSION_MODAL_OPEN");

/**
 * @module COLLECTORS
 * @desc set selected collector
 */
export const SET_SELECTED_DOCUMENT = prefix("SET_SELECTED_DOCUMENT");

/**
 * @module COLLECTORS
 * @desc set data version modal open state
 */
export const SAGAS_GET_TABLE_COLLECTORS = prefix("SAGAS_GET_TABLE_COLLECTORS");

/**
 * @module COLLECTORS
 * @desc set selected collector
 */
export const SAGAS_GET_EXTRACTED_TABLE_COLLECTOR = prefix("SAGAS_GET_EXTRACTED_TABLE_COLLECTOR");

/**
 * @module COLLECTORS
 * @desc set data version modal open state
 */
export const SET_TABLE_COLLECTORS = prefix("SET_TABLE_COLLECTORS");

/**
 * @module COLLECTORS
 * @desc set selected collector
 */
export const SET_SELECTED_TABLE_COLLECTOR = prefix("SET_SELECTED_TABLE_COLLECTOR");

/**
 * @module COLLECTORS
 * @desc set selected collector
 */
export const SET_EXTRACTED_TABLE_COLLECTOR = prefix("SET_EXTRACTED_TABLE_COLLECTOR");

/**
 * @module COLLECTORS
 * @desc handle toc open
 */
export const HANDLE_TOC_OPEN = prefix("HANDLE_TOC_OPEN");

export const SAGAS_GET_ENTITIES = prefix("SAGAS_GET_ENTITIES");
export const SET_ENTITIES = prefix("SET_ENTITIES");

export const SAGAS_GET_DB_COLUMNS = prefix("SAGAS_GET_DB_COLUMNS");
export const SET_DB_COLUMNS = prefix("SET_DB_COLUMNS");

export const SAGAS_GET_PREPROCESSING_FUNCTIONS = prefix("SAGAS_GET_PREPROCESSING_FUNCTIONS");
export const SET_PREPROCESSING_FUNCTIONS = prefix("SET_PREPROCESSING_FUNCTIONS");

export const SAGAS_GET_AUTO_EXTRACTOR_CONFIGS = prefix("SAGAS_GET_AUTO_EXTRACTOR_CONFIGS");
export const SET_DOCUMENT_CONFIGS = prefix("SET_DOCUMENT_CONFIGS");

export const SAGAS_SAVE_AUTO_EXTRACTOR_CONFIG = prefix("SAGAS_SAVE_AUTO_EXTRACTOR_CONFIG");
export const SAGAS_POST_AUTO_EXTRACTOR_PREVIEW = prefix("SAGAS_POST_AUTO_EXTRACTOR_PREVIEW");
export const SAGAS_GET_AUTO_EXTRACTOR_PREVIEW_JOB = prefix("SAGAS_GET_AUTO_EXTRACTOR_PREVIEW_JOB");

/**
 * @module COLLECTORS
 * @desc export selected table collector as excel/json
 */
export const SAGAS_EXPORT_TABLE = prefix("SAGAS_EXPORT_TABLE");
